import React, { useState } from "react";
import { FiCheckCircle } from "react-icons/fi";
import { FaShieldAlt } from "react-icons/fa";

const WhyChoose = () => {
  const [activeIndex, setActiveIndex] = useState(2);

  const highlights = [
    "Trusted Expertise In Technology",
    "Commitment To Client Success",
    "Innovative Solutions For Growth",
  ];

  return (
    <section className="relative overflow-hidden bg-black text-white">
      {/* 🌊 Top Wave Transition */}
      <svg
        className="absolute top-0 left-0 w-full z-0"
        viewBox="0 0 1440 320"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path fill="#000" d="M0,160L60,144C120,128,240,96,360,101.3C480,107,600,149,720,165.3C840,181,960,171,1080,149.3C1200,128,1320,96,1380,80L1440,64L1440,0L0,0Z"></path>
      </svg>

      {/* ✨ Slight Dark Gradient Background */}
      <div className="absolute inset-0 z-0 bg-gradient-to-b from-black via-gray-900 to-black"></div>

      {/* Glow Behind Section */}
      <div className="absolute -z-10 w-[900px] h-[900px] bg-white/10 rounded-full blur-[200px] opacity-20 top-1/2 left-[-200px]"></div>

      {/* Soft white particles */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {[...Array(15)].map((_, i) => (
          <div
            key={i}
            className="absolute bg-white rounded-full opacity-40 blur-[2px]"
            style={{
              width: `${Math.random() * 6 + 2}px`,
              height: `${Math.random() * 6 + 2}px`,
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              animation: `floatParticle ${6 + Math.random() * 6}s ease-in-out infinite`,
              animationDelay: `${Math.random() * 5}s`,
            }}
          ></div>
        ))}
      </div>

      {/* MAIN CONTENT */}
      <div className="relative z-10 py-28 px-6 sm:px-10 lg:px-20 max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-16 items-center">

          {/* LEFT SIDE */}
          <div className="space-y-8">
            <div>
              <span className="text-sm font-semibold text-[#df2313] uppercase tracking-widest">
                Why Choose Us
              </span>

              <h2 className="text-4xl sm:text-5xl font-bold mt-3 leading-tight text-white">
                Driven By Quality, <br />
                <span className="text-[#df2313] font-bold">Focused</span> On Your Digital Growth
              </h2>

              <p className="text-gray-300 mt-5 text-lg max-w-md leading-relaxed">
                Skilled in collaboration and precision — we build adaptable,
                future-ready solutions that empower businesses to grow with
                confidence and clarity.
              </p>
            </div>

            {/* Highlights */}
            <div className="flex flex-col gap-4 pt-4">
              {highlights.map((item, idx) => (
                <div
                  key={idx}
                  className="group flex items-center gap-3 bg-white/10 backdrop-blur-sm p-3 rounded-full shadow-sm 
                 transition-all duration-300 hover:scale-[1.05]"
                >
                  {/* TICK ICON → white normally / red on hover */}
                  <FiCheckCircle
                    className="text-white text-xl transition-all duration-300 group-hover:text-[#df2313]"
                  />

                  {/* Text stays same */}
                  <span className="text-gray-200 font-medium">
                    {item}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="relative flex flex-col justify-center items-center gap-8">

            {/* IMAGE WITH WHITE GLOW (not blue anymore) */}
            <div className="relative group">
              {/* White glow */}
              <div className="absolute -inset-4 bg-white opacity-10 blur-2xl rounded-3xl group-hover:opacity-20 transition-all duration-700"></div>

              <img
                src="/teamworking.jpg"
                alt="Team working"
                className="relative w-full max-w-[680px] rounded-3xl object-cover shadow-2xl group-hover:shadow-white/30 transition-all duration-700"
              />
            </div>

            {/* Warranty Badge */}
            <div className="relative bg-gradient-to-r from-[#df2313] to-[#df2313] text-white rounded-2xl p-6 w-fit text-center shadow-xl hover:scale-105 transition-all">
              <FaShieldAlt className="text-4xl mx-auto mb-3" />
              <p className="text-base font-semibold tracking-wide">Warranty & Quality Assurance</p>
              <p className="text-xs mt-1 opacity-80">Crafting excellence with precision & trust</p>
            </div>

          </div>
        </div>
      </div>

      {/* Animations */}
      <style>{`
        @keyframes floatParticle {
          0%, 100% { transform: translateY(0px); opacity: 0.6; }
          50% { transform: translateY(-20px); opacity: 1; }
        }
      `}</style>
    </section>
  );
};

export default WhyChoose;
